import { UIStoreItemView } from './UIStoreItemView.ts';
import { areYouSureToBuy, areYouSureToBuyFounderDiscount, doActionIfCanGiftMembership, doActionIfLoggedIn } from '../../../shared/scripts/store/StoreUtils.ts';
import { UIStoreAjaxEndPoints } from '../../../shared/scripts/store/UIStoreAjaxEndPoints.ts';
import { StoreItemCategory, StorePresalePackType } from '../../../../shared/entity_datas/StoreEnums.ts';
import { StoreItemController } from '../../../../shared/store/StoreItemController.ts';
import { CA } from '../../../shared/scripts/analytics/Analytics.ts';
import { AnalyticEventCategory, AnalyticEventType } from '../../../../shared/entity_datas/EntityDatas.ts';
import { ColonistCoinProduct } from '../../../../shared/store/ColonistCoinProduct.ts';
import { UICoinProductView } from '../../../shared/scripts/store/UICoinProductView.ts';
import { UIStoreMembershipProductView } from '../../../shared/scripts/store/UIStoreMembershipProductView.ts';
import { ColonistMembershipProduct } from '../../../../shared/store/ColonistMembershipProduct.ts';
import { UIStoreMembershipTabsController } from '../../../shared/scripts/store/UIStoreMembershipTabsController.ts';
import { applyOwnedMembershipToViews } from '../../../shared/scripts/store/applyOwnedMembershipToViews.ts';
import * as Item from '../../../../shared/store/StoreItemList.ts';
import { UIStoreBodyController } from '../../../shared/scripts/store/UIStoreBodyController.ts';
import { UIGiftedMembershipProductView } from '../../../shared/scripts/store/UIGiftedMembershipProductView.ts';
import { ColonistMembershipPerkType } from '@colonist/lobby-types';
import { ClientUserState } from '../../../shared/scripts/ClientUserState.ts';
import { UIStoreGiftOverlayController } from '../../../shared/scripts/store/gift/UIStoreGiftOverlayController.ts';
import { navigateToPage } from '../../../shared/scripts/ui_utils/ClientUtils.ts';
import { showReferFriendsDialog } from '../../../shared/scripts/ui_popup/showReferFriendsDialog.ts';
export class UIWStoreBodyController extends UIStoreBodyController {
    createGiftOverlay() {
        const mainContainer = document.getElementById('store_main_container');
        const pageBody = mainContainer.parentElement;
        this.giftOverlayController = new UIStoreGiftOverlayController(pageBody, this.storeState);
    }
    createMembershipItems() {
        this.membershipsDiv.replaceChildren();
        this.membershipItems.length = 0;
        const membershipProducts = ColonistMembershipProduct.getAllMembershipProducts();
        for (const product of membershipProducts){
            const membership = new UIStoreMembershipProductView(this.membershipsDiv, this.storeState, product, this.giftOverlayController);
            this.membershipItems.push(membership);
        }
        this.membershipTabsController = new UIStoreMembershipTabsController(this.storeState);
    }
    updateAllCategoryItems() {
        this.items.length = 0;
        this.updateCategoryItems(StoreItemCategory.Expansion, this.expansionsDiv);
        this.updateCategoryItems(StoreItemCategory.Map, this.mapsDiv);
        this.updateCategoryItems(StoreItemCategory.Color, this.colorsDiv);
        this.updateCategoryItems(StoreItemCategory.Icon, this.avatarsDiv);
    }
    createCoinProducts() {
        const coinProducts = ColonistCoinProduct.getAllCoinProducts();
        for (const product of coinProducts){
            new UICoinProductView(this.coinsDiv, product);
        }
    }
    updateCategoryItems(category, container) {
        container.replaceChildren();
        const itemDetails = StoreItemController.getItemsInCategory(category);
        for (const itemDetail of itemDetails){
            const item = new UIStoreItemView(container, itemDetail, ()=>doActionIfCanGiftMembership(()=>this.giftOverlayController.show()), ()=>{
                const eventData = {
                    type: AnalyticEventType.StoreClickedPurchaseItem,
                    category: AnalyticEventCategory.Store,
                    floatValue: item.itemDetail.type
                };
                void CA.sendAnalyticEvent(eventData);
                const isBlackColor = itemDetail.name.key === new Item.SIColorBlack().name.key;
                if (!isBlackColor) {
                    var _ClientUserState_userState;
                    var _ClientUserState_userState_forceSubscription;
                    const forceSubscription = (_ClientUserState_userState_forceSubscription = (_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.forceSubscription) !== null && _ClientUserState_userState_forceSubscription !== void 0 ? _ClientUserState_userState_forceSubscription : true;
                    const subscriptionCategory = itemDetail.category == StoreItemCategory.Expansion || itemDetail.category == StoreItemCategory.Map || itemDetail.category == StoreItemCategory.Color;
                    if (forceSubscription && subscriptionCategory) {
                        navigateToPage('/store#membership');
                        return;
                    }
                }
                doActionIfLoggedIn(()=>{
                    areYouSureToBuy(itemDetail, ()=>{
                        void UIStoreAjaxEndPoints.purchaseItem(itemDetail);
                    });
                });
            });
            this.items.push(item);
        }
    }
    updateOwnedItems(ownedItems) {
        this.updateAllCategoryItems();
        void this.updateReferralProgram();
        for (const ownedItem of ownedItems){
            for (const itemView of this.items){
                if (itemView.itemDetail.name.key == ownedItem.name.key) {
                    itemView.markAsOwned();
                    break;
                }
            }
        }
    }
    updateSubscribedItems(ownedMembership, paymentMethod) {
        if (ownedMembership == undefined) return;
        for (const perk of ownedMembership.perks){
            if (perk.type == ColonistMembershipPerkType.AllColors) {
                this.markItemsAsSubscribed(StoreItemCategory.Color);
            }
            if (perk.type == ColonistMembershipPerkType.AllMaps) {
                this.markItemsAsSubscribed(StoreItemCategory.Map);
            }
            if (perk.type == ColonistMembershipPerkType.AllExpansions) {
                this.markItemsAsSubscribed(StoreItemCategory.Expansion);
            }
        }
    }
    markItemsAsSubscribed(category) {
        for (const itemView of this.items){
            if (itemView.itemDetail.category != category) continue;
            itemView.markAsSubscribed();
        }
    }
    updateOwnedMembership(ownedMembership, paymentMethod) {
        this.createMembershipItems();
        applyOwnedMembershipToViews(this.membershipItems, ownedMembership, paymentMethod);
    }
    updatePriceForFounderPack(ownedItems) {
        const hasFounderPack = UIWStoreBodyController.hasFounderPack(ownedItems);
        if (!hasFounderPack) return;
        for (const itemView of this.items){
            if (itemView.isMarkedOwned) continue;
            if (itemView.itemDetail.category != StoreItemCategory.Expansion && itemView.itemDetail.category != StoreItemCategory.Map) continue;
            itemView.makePrice0();
            itemView.updateAction(()=>{
                areYouSureToBuyFounderDiscount(itemView.itemDetail, ()=>{
                    void UIStoreAjaxEndPoints.purchaseItem(itemView.itemDetail);
                });
            });
        }
    }
    updateGiftedMemberships(memberships) {
        var _document_getElementById;
        const grid = document.getElementById('store_page_gifted_memberships_div');
        if (grid == undefined) return;
        grid.replaceChildren();
        (_document_getElementById = document.getElementById('gifted_memberships')) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.classList.toggle('hidden', memberships.length == 0);
        for (const membership of memberships){
            new UIGiftedMembershipProductView(grid, this.storeState, membership, async (id)=>{
                await UIStoreAjaxEndPoints.activateGiftedMembership(id);
            });
        }
    }
    static hasFounderPack(ownedItems) {
        for (const item of ownedItems){
            if (item.category != StoreItemCategory.PresalePack) continue;
            if (item.type != StorePresalePackType.FounderPack) continue;
            return true;
        }
        return false;
    }
    // eslint-disable-next-line class-methods-use-this
    onInviteFriendsButtonClick(referralReward, userReferralCount) {
        void showReferFriendsDialog(referralReward, userReferralCount);
    }
    onStoreViewVisible() {
        void this.updateReferralProgram();
    }
    constructor(storeState){
        super(), this.items = [], this.membershipItems = [];
        this.membershipsDiv = document.getElementById('store_page_memberships_div');
        this.expansionsDiv = document.getElementById('store_page_expansions_div');
        this.mapsDiv = document.getElementById('store_page_maps_div');
        this.colorsDiv = document.getElementById('store_page_colors_div');
        this.avatarsDiv = document.getElementById('store_page_avatars_div');
        this.coinsDiv = document.getElementById('store_page_coins_div');
        this.storeState = storeState;
        this.createGiftOverlay();
        this.createMembershipItems();
        this.updateAllCategoryItems();
        this.createCoinProducts();
    }
}
